import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function GuestGuard() {
  const user = useSelector((s) => s.auth.user);

  return user ? <Navigate to="/" replace /> : <Outlet />;
}
